import type { Point2, StoneFinding } from "./types";

type Crop = { x: number; y: number; w: number; h: number };

export function mapPointToCanvas(p: Point2, crop: Crop, canvasW: number, canvasH: number): Point2 {
  return [((p[0] - crop.x) / crop.w) * canvasW, ((p[1] - crop.y) / crop.h) * canvasH];
}

export function caliperCanvasSegments(stone: StoneFinding, canvasW: number, canvasH: number) {
  const c = stone.cropBoundsPx;
  const m = (p: Point2) => mapPointToCanvas(p, c, canvasW, canvasH);
  return {
    long: [m(stone.longAxisPx[0]), m(stone.longAxisPx[1])] as [Point2, Point2],
    short: [m(stone.shortAxisPx[0]), m(stone.shortAxisPx[1])] as [Point2, Point2],
  };
}
